import React, { Component } from 'react';
import { View, Text } from 'react-native';
import utils from '../utils';
import { enabledStyle, disabledStyle } from '../commonStyles';

const statusMap: { [propName: string]: string } = {
    10: 'isWarning',
    11: 'isWarning'
};
const appActionMap: { [propName: string]: boolean } = {
    pay: true
};
const titleMap: { [propName: string]: string } = {
    1004001: '酒店-钟点房',
    1005001: '酒店-钟点房',
    3002001: '团购-钟点房',
    9001001: '公寓-钟点房'
};

interface Props {
    productTitle: string;
    deadlineInfo: string;
    roomInfo: string;
    _disable: boolean;
}
class HotelGroupClass extends Component {
    public static formatData = (data: any) => {
        const newData = { ...data };
        // 订单状态
        newData._orderStatus = statusMap[newData.status];
        // icon
        newData.title = titleMap[newData.orderType] ? titleMap[newData.orderType] : '钟点房';
        newData.iconfont = '\uf1f5';
        newData.iconColor = '#fe5d5d';
        // 按钮
        newData.actionInfos = utils.buildActionInfos(newData.appAction, appActionMap);
        // 价格
        newData.currency = (newData.currency || '').trim();
        newData.fixPrice = utils.fixPrice(newData.price, newData.currency);
        newData.fixConvertPrice = utils.fixPrice(newData.convertPrice);
        // 截止日期小黄条
        if (newData.deadline) {
            newData.deadlineInfo = `${utils.buildDateTime(newData.deadline)} 前入住`;
        } else {
            newData.deadlineInfo = '入住时间以酒店确认为准';
        }
        newData.roomInfo = buildRoomInfoStr(newData) || '';

        return newData;
    };

    public render() {
        const { data: { productTitle, deadlineInfo, roomInfo, _disable } = {} } = this.props;
        const styles = _disable ? disabledStyle : enabledStyle;

        return (
            <View style={styles.left}>
                <Text numberOfLines={2} style={styles.newOrderTitle}>
                    {productTitle}
                </Text>
                <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                    {deadlineInfo}
                </Text>
                <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                    {roomInfo}
                </Text>
            </View>
        );
    }
}

export default HotelGroupClass;

function buildRoomInfoStr(data: { hourRoomType: number; hourCount: number; roomType: string }) {
    const result = [];
    if (data) {
        if (data.hourRoomType === 0) {
            data.hourCount && result.push(`${data.hourCount}小时  `);
        } else if (data.hourRoomType === 1) {
            result.push('可过夜  ');
        } else if (data.hourRoomType === 2) {
            result.push('长时段  ');
        }

        data.roomType && result.push(data.roomType);
    }
    return result.join(' ');
}
